/* STORE MENU */
export const FETCH_STORE_MENU = "FETCH_STORE_MENU";
export const FETCH_STORE_MENU_SUCCESS = "FETCH_STORE_MENU_SUCCESS";
export const FETCH_STORE_MENU_FAILURE = "FETCH_STORE_MENU_FAILURE";

export const FETCH_MENU_COLUMNS_SUCCESS = "FETCH_MENU_COLUMNS_SUCCESS";


